"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.982 6.812a2.825 2.825 0 0 0-3.964 0 2.74 2.74 0 0 0 0 3.906 2.825 2.825 0 0 0 3.964 0 2.74 2.74 0 0 0 0-3.906m-4.95-.995a4.225 4.225 0 0 1 5.935 0 4.14 4.14 0 0 1 0 5.896 4.225 4.225 0 0 1-5.934 0 4.14 4.14 0 0 1 0-5.896M6.5 15.195c-1.166 0-2.1.934-2.1 2.072v1.386a.7.7 0 1 1-1.4 0v-1.386c0-1.924 1.574-3.472 3.5-3.472h7c1.926 0 3.5 1.548 3.5 3.472v1.386a.7.7 0 1 1-1.4 0v-1.386c0-1.138-.934-2.072-2.1-2.072zm15.993-5.596a.7.7 0 0 1 .004.99l-3.1 3.125a.7.7 0 0 1-.994 0l-1.9-1.915a.7.7 0 0 1 .994-.986l1.403 1.414 2.603-2.624a.7.7 0 0 1 .99-.004",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UserWithCheckmarkIcon24.js.map